import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/zoom";
import "swiper/css/free-mode";
import "swiper/css/thumbs";

import FindMate from "@assets/images/games/find-mate/find-mate-banner.png";
import GuessPicture from "@assets/images/games/guess-picture/guess-picture-banner.png";
import WordPuzzles from "@assets/images/games/word-puzzles/word-puzzles.png";
import LuckyWheel from "@assets/images/games/lucky-wheel/luckywheel-banner.png";
import ScoreHunt from "@assets/images/games/score-hunt/score-hunt-banner.png";
import WhoWantsScore from "@assets/images/games/who-wants-score/who-wants-score-banner.png";

// Styles
import "./styles.scss";

import $ from "jquery";

const HomeGames = ({ tenantPaths = [] }) => {
  const activeComponents = useSelector((store) => store.auth.activeComponents);
  const loginSettings = useSelector((store) => store.auth.loginSettings);

  // Active Component Check
  const isComponentActive = (componentName) => {
    // If componentName is not specified, always consider it active
    if (!componentName) return true;

    // componentList check
    if (!activeComponents || !activeComponents.length) return false;

    // Active component find
    return activeComponents.some(
      (item) => item.active && item.componentName === componentName
    );
  };

  // Oyunların listesini ve yetki kontrolünü bir dizi üzerinde tanımlayalım
  const allGames = [
    { id: "find-mate", name: "EŞLE KAZAN", path: "/games/find-mate", title: "Eşini Bul", desc: "Eşini bul oyunu ile eğlenceli vakit geçirin.", img: FindMate, link: "/games/find-mate" },
    { id: "word-puzzles", name: "KELİME AVI", path: "/games/word-puzzles", title: "Kelime Bulmaca", desc: "Kelime bulmaca oyunu ile eğlenceli vakit geçirin.", img: WordPuzzles, link: "/games/word-puzzles" },
    { id: "score-hunt", name: "PUAN AVI", path: "/games/score-hunt", title: "Puan Avı", desc: "Puan Avı sembolünü bulunan ürünü bulun ve soruya ulaşın.", img: ScoreHunt, link: "/games/score-hunt" },
    { id: "guess-picture", name: "RESMİ TAHMİN ET", path: "/games/guess-picture", title: "Resmi Tahmin Et", desc: "Resmi tahmin edin ve hediye kazanma şansı yakalayın.", img: GuessPicture, link: "/games/guess-picture" },
    { id: "question-wheel", name: "ŞANS ÇARKI", path: "/games/question-wheel", title: "Şans Çarkı", desc: "Şans çarkı oyunu ile eğlenceli vakit geçirin.", img: LuckyWheel, link: "/games/question-wheel" },
    { id: "who-wants-score", name: "KİM 1000 PUAN İSTER", path: "/games/who-wants-score", title: "Kim 1000 Puan İster", desc: "Kim 1000 puan ister oyunu ile eğlenceli vakit geçirin.", img: WhoWantsScore, link: "/games/who-wants-score" },
    // TODO: En İyi Tabak için kendi banner görseli eklenince img güncellensin (şimdilik placeholder)
    { id: "best-plate", name: "EN İYİ TABAK", path: "/games/best-plate", title: "En İyi Tabağını Yükle", desc: "En iyi tabağını yükle, oyla ve haftanın birincisi ol.", img: GuessPicture, link: "/games/best-plate" },
  ];

  // Sadece aktif ve yetkisi olan oyunları filtrele
  const visibleGames = allGames.filter(game =>
    isComponentActive(game.name) && !tenantPaths.includes(game.path)
  );

  // Az oyun olduğunda (1-2 adet) slider yerine ortalanmış sabit düzen kullan
  const useSlider = visibleGames.length > 2;

  // Dikey oyun kartı (slider içinde kullanılır)
  const renderGameCard = (game) => (
    <div className={`gameItem h-100 ${game.id === 'score-hunt' ? 'Link' : ''}`}>
      <div className="bg-white shadow-sm rounded-3 px-4 pb-sm-5 pb-4 text-center h-100">
        <div className="image shadow-sm bg-white rounded-circle">
          <img src={game.img} alt={game.title} />
        </div>
        <h2 className="mb-4 fw-bold text-blue lh-sm">{game.title}</h2>
        <p className="mb-4 small">{game.desc}</p>
        <Link
          to={game.link}
          className="btn btn-blue rounded-pill py-sm-3 py-2 px-sm-4 px-3"
        >
          Başla
        </Link>
      </div>
    </div>
  );

  useEffect(() => {
    var sliderGames = ".sliderGames";
    if (useSlider && $(sliderGames).length && visibleGames.length > 0) {
      // eslint-disable-next-line no-undef
      var swiper = new Swiper(sliderGames, {
        centerInsufficientSlides: true, // Slayt sayısı az ise ortalar
        breakpoints: {
          0: {
            slidesPerView: 1.5,
          },
          576: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        spaceBetween: -8,
        pagination: {
          el: sliderGames + " " + ".swiper-pagination",
          clickable: true,
        },
      });
    }
  }, []);

  return (
    <section className="games-section pt-5 pb-5">
      <div className="container px-0">
        <h1 className="text-center mb-5">Oyunlar</h1>
        {useSlider ? (
          <div className="swiper sliderGames">
            <div className="swiper-wrapper mb-sm-5 mb-4">
              {visibleGames.map((game) => (
                <div className="swiper-slide h-auto p-3" key={game.id}>
                  {renderGameCard(game)}
                </div>
              ))}
            </div>

            <div className="swiper-pagination"></div>
            <div className="swiper-button-next">
              <i className="fas fa-chevron-right" style={{ fontSize: "2rem", color: `${loginSettings?.blue}` }}></i>
            </div>
            <div className="swiper-button-prev text-lg">
              <i className="fas fa-chevron-left" style={{ fontSize: "2rem", color: `${loginSettings?.blue}` }}></i>
            </div>
          </div>
        ) : visibleGames.length === 1 ? (
          // Tek oyun: ortalanmış geniş kart (logo üstten taşan standart kart)
          <div className="games-static games-static--1 d-flex justify-content-center mb-sm-5 mb-4">
            <div className="games-static-item p-3">
              {renderGameCard(visibleGames[0])}
            </div>
          </div>
        ) : (
          // İki oyun: 2 kolonlu dikey kart grid, butonlar altta hizalı
          <div className="games-static-grid mb-sm-5 mb-4">
            {visibleGames.map((game) => (
              <div className="games-static-grid-item p-3" key={game.id}>
                {renderGameCard(game)}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
export default HomeGames;
